import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isNonNaNNumber } from '@iotv/iotv-v3-types';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { useContext } from 'react';
import { HistoryStoreContext } from '../../ContextProviders/HistoryStoreContext';
import { getNiceDate } from '../../data/TypeHelpers';
import { StripedDataGrid } from '../factories/DataGrid';
import { fontSize } from '../NetworkSystem/cellFormatters/fontSize';
const debug = process.env.REACT_APP_DEBUG && false;
const commonColDef = {
    editable: false,
    sortable: false,
    flex: 1,
};
const typedColumns = [
    {
        field: 'firstTimestamp',
        headerName: 'First Timestamp',
        ...commonColDef,
        valueFormatter: (value) => (isNonNaNNumber(value) ? getNiceDate(value) : value),
    },
    {
        field: 'lastTimeStamp',
        headerName: 'Last Timestamp',
        ...commonColDef,
        valueFormatter: (value) => (isNonNaNNumber(value) ? getNiceDate(value) : value),
    },
    {
        field: 'count',
        headerName: 'Count',
        ...commonColDef,
        type: 'number',
    },
    {
        field: 'min',
        headerName: 'Min',
        ...commonColDef,
        type: 'number',
        valueFormatter: (value) => (isNonNaNNumber(value) ? value.toFixed(1) : value),
    },
    {
        field: 'mean',
        headerName: 'Mean',
        ...commonColDef,
        type: 'number',
        valueFormatter: (value) => (isNonNaNNumber(value) ? value.toFixed(1) : value),
    },
    {
        field: 'max',
        headerName: 'Max',
        ...commonColDef,
        type: 'number',
        valueFormatter: (value) => (isNonNaNNumber(value) ? value.toFixed(1) : value),
    },
    {
        field: 'sdPop',
        headerName: 'Std. Dev.',
        ...commonColDef,
        type: 'number',
        valueFormatter: (value) => (isNonNaNNumber(value) ? value.toFixed(1) : value),
    },
];
const columns = [{ field: 'id', headerName: 'Metric', ...commonColDef }, ...typedColumns];
/** Expects to draw data from a {@link HistoryStoreContext | `HistoryStoreContext`} */
export default function ObjectHistoryStatistics({ title }) {
    const { controls: { timeSelectorComponents }, historyStore, loadingObjectHistory, } = useContext(HistoryStoreContext);
    const { TimePeriodSelector } = timeSelectorComponents;
    if (!historyStore)
        return _jsx(CircularProgress, { size: '1.5em' });
    const hasStats = 0 < Object.keys(historyStore.getStatistics()).length;
    debug && console.log(`ObjectHistoryStatistics history store has stats?`, hasStats);
    const statistics = hasStats ? historyStore.getStatistics() : historyStore.generateStatistics();
    const dataGridProps = {
        columns,
        rows: Object.entries(statistics)
            .sort(([k1], [k2]) => (k1.toLowerCase() < k2.toLowerCase() ? -1 : 1))
            .map(([k, v]) => {
            return { id: k, ...v };
        }),
        loading: loadingObjectHistory,
        columnHeaderHeight: 40,
        disableColumnMenu: true,
        rowHeight: 24,
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        hideFooter: true,
    };
    return (_jsxs(Stack, { paddingBlockStart: 1, gap: 1, children: [title && _jsx(Typography, { children: title }), TimePeriodSelector, _jsx(StripedDataGrid, { style: { fontSize }, ...dataGridProps })] }));
}
